import { Box, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import Logo from "./logo.png";
import Word from "./word.png";
import TomatoXL from "./img/tomatoPlant_x1440.png";
import TomatoLG from "./img/tomatoPlant_x1024.png";
import TomatoMD from "./img/tomatoPlant_x768.png";
import TomatoSM from "./img/tomatoPlant_x600.png";
import TomatoS from "./img/tomatoPlant_x375.png";
import { Link } from "react-router-dom";
import ResponsivePicture from "../../component/ResponsivePicture";
import FullPageBackgroundContainer from "../../component/FullPageBackgroundContainer";
// import PopupBanner from "./PopupBanner";
const useStyles = makeStyles((theme) => ({
  title: {
    position: "absolute",
    right: "60px",
    top: "60px",
    [theme.breakpoints.between("md", "md")]: {
      right: "20px",
      top: "120px",
    },
    [theme.breakpoints.between("sm", "sm")]: {
      right: "10px",
      top: "160px",
    },
    [theme.breakpoints.between("s", "s")]: {
      right: "10px",
      top: "70px",
    },
    [theme.breakpoints.down("xs")]: {
      right: "10px",
      top: "40px",
    },
  },
  actualTitle: {
    color: "white",
    fontSize: "24px",
    [theme.breakpoints.between("lm", "lm")]: {
      fontSize: "18px",
    },
    [theme.breakpoints.between("md", "md")]: {
      fontSize: "16px",
    },
    [theme.breakpoints.between("sm", "sm")]: {
      fontSize: "14px",
    },
    [theme.breakpoints.between("s", "s")]: {
      fontSize: "12px",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "10px",
    },
  },
  logo: {
    width: "auto",
    height: "auto",
    [theme.breakpoints.between("lm", "lm")]: {
      width: "70px",
    },
    [theme.breakpoints.between("md", "md")]: {
      width: "60px",
    },
    [theme.breakpoints.between("sm", "sm")]: {
      width: "50px",
    },
    [theme.breakpoints.between("s", "s")]: {
      width: "40px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "35px",
    },
  },
  word: {
    width: "auto",
    height: "auto",
    [theme.breakpoints.between("lm", "lm")]: {
      width: "280px",
    },
    [theme.breakpoints.between("md", "md")]: {
      width: "255px",
    },
    [theme.breakpoints.between("sm", "sm")]: {
      width: "210px",
    },
    [theme.breakpoints.between("s", "s")]: {
      width: "180px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "150px",
    },
  },

  imgLinks: {
    position: "relative",
    display: "inline-block",
  },
  firstLink: {
    width: "150px",
    height: "150px",

    borderRadius: "50%",
    position: "absolute",
    top: "10%",
    right: "180px",
    [theme.breakpoints.between("lg", "lg")]: {
      top: "10%",
      width: "120px",
      height: "120px",
      right: "140px",
    },
    [theme.breakpoints.between("lm", "lm")]: {
      top: "10%",
      width: "120px",
      height: "120px",
      right: "140px",
    },
    [theme.breakpoints.between("md", "md")]: {
      width: "120px",
      height: "120px",
      right: "100px",
      top: "5%",
    },
    [theme.breakpoints.between("sm", "sm")]: {
      width: "120px",
      height: "120px",
      right: "90px",
      top: "8%",
    },
    [theme.breakpoints.between("s", "s")]: {
      width: "120px",
      height: "120px",
      right: "90px",
      top: "260px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100px",
      height: "100px",
      right: "90px",
      top: "30%",
    },
  },
  secondLink: {
    width: "150px",
    height: "150px",

    borderRadius: "50%",
    position: "absolute",
    top: "33%",
    left: "30px",
    [theme.breakpoints.between("lm", "lm")]: {
      width: "120px",
      height: "120px",
    },
    [theme.breakpoints.between("md", "md")]: {
      width: "120px",
      height: "120px",
      top: "23%",
      left: "15px",
    },
    [theme.breakpoints.between("sm", "sm")]: {
      width: "120px",
      height: "120px",
      top: "33%",
      left: "15px",
    },
    [theme.breakpoints.between("s", "s")]: {
      width: "100px",
      height: "100px",
      top: "48%",
      left: "15px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100px",
      height: "100px",
      top: "48%",
      left: "15px",
    },
  },
  thirdLink: {
    width: "170px",
    height: "170px",

    borderRadius: "50%",
    position: "absolute",
    bottom: "35%",
    right: "120px",
    [theme.breakpoints.between("lm", "lm")]: {
      width: "170px",
      height: "170px",
    },
    [theme.breakpoints.between("md", "md")]: {
      width: "120px",
      height: "120px",
      bottom: "45%",
      right: "80px",
    },
    [theme.breakpoints.between("sm", "sm")]: {
      width: "110px",
      height: "110px",
      bottom: "40%",
      right: "80px",
    },
    [theme.breakpoints.between("s", "s")]: {
      width: "100px",
      height: "100px",
      bottom: "27%",
      right: "80px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "80px",
      height: "80px",
      bottom: "28%",
      right: "55px",
    },
  },
  fourthLink: {
    width: "170px",
    height: "170px",

    borderRadius: "50%",
    position: "absolute",
    bottom: "10%",
    left: "40px",
    [theme.breakpoints.between("lm", "lm")]: {
      width: "170px",
      height: "170px",
    },
    [theme.breakpoints.between("md", "md")]: {
      width: "120px",
      height: "120px",
      bottom: "20%",
      left: "30px",
    },
    [theme.breakpoints.between("sm", "sm")]: {
      width: "110px",
      height: "110px",
      bottom: "15%",
      left: "30px",
    },
    [theme.breakpoints.between("s", "s")]: {
      width: "100px",
      height: "100px",
      bottom: "10%",
      left: "30px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "80px",
      height: "80px",
      bottom: "10%",
      left: "30px",
    },
  },
  fitfhLink: {
    width: "170px",
    height: "170px",

    borderRadius: "50%",
    position: "absolute",
    bottom: "8%",
    right: "0px",
    [theme.breakpoints.between("lm", "lm")]: {
      width: "170px",
      height: "170px",
    },
    [theme.breakpoints.between("md", "md")]: {
      width: "120px",
      height: "120px",
      bottom: "8%",
      right: "0px",
    },
    [theme.breakpoints.between("sm", "sm")]: {
      width: "110px",
      height: "110px",
      bottom: "8%",
      right: "0px",
    },
    [theme.breakpoints.between("s", "s")]: {
      width: "100px",
      height: "100px",
      bottom: "8%",
      right: "0px",
    },
    [theme.breakpoints.down("xs")]: {
      width: "80px",
      height: "80px",
      bottom: "8%",
      right: "0px",
    },
  },
}));

export default function LandingTomatoPage() {
  const classes = useStyles();
  return (
    <FullPageBackgroundContainer background="landingPage--background">
      <Box className={classes.imgLinks}>
        <ResponsivePicture
          lg={TomatoXL}
          lm={TomatoLG}
          md={TomatoMD}
          sm={TomatoSM}
          s={TomatoS}
          styling="tomatoPlant"
          title="tomato plant"
        />
        <Link to="/about" className={classes.firstLink}></Link>
        <Link to="/vegetablesItem" className={classes.secondLink} />
        <Link to="/news" className={classes.thirdLink} />
        <Link to="/recruit" className={classes.fourthLink}></Link>
        <Link to="/contact" className={classes.fitfhLink}></Link>
      </Box>

      <Box className={classes.title}>
        <Link to="/">
          <img src={Word} alt="word" className={classes.logo} />
        </Link>
        <img src={Logo} alt="logo" className={classes.word} />

        <Typography className={classes.actualTitle} variant="body1">
          安心・安全、おいしい野菜をお届けします
        </Typography>
      </Box>
    </FullPageBackgroundContainer>
  );
}
